import PropTypes from "prop-types";
import PhotoCloudfront from "components/shared/adventures/PhotoCloudfront";
import Image from "next/image";

export default function ImageOrCloudfront({
  image,
  className,
  altName,
  sizeTemplate = undefined,
  priority = false,
}) {
  if (image) {
    if (image.url) {
      return (
        <PhotoCloudfront
          src={image.url}
          width={image.width}
          height={image.height}
          className={className}
          alt={altName}
          sizeTemplate={sizeTemplate}
          priority={priority}
        />
      );
    }
    return (
      <Image
        src={image}
        width={image?.width}
        height={image?.height}
        placeholder="blur"
        className={className}
        alt={altName}
      />
    );
  }
}

ImageOrCloudfront.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  className: PropTypes.node.isRequired,
  altName: PropTypes.string.isRequired,
  sizeTemplate: PropTypes.string,
  priority: PropTypes.bool,
};
